module.exports = __webpack_public_path__ + "static/img/A49.e24f4c74.jpg";